import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Components //
import TitleSection from "../../molecules/title-section";
import IconCard from "../../molecules/icon-card/iconCard";

// Styles //
import "./bePartCommunities.scss";

const BePartCommunities = (props: ReferenciaContenido) => {
    const {
        tituloGeneral,
        descripcion,
        imagenPrincipal,
        referenciaPlantillaContenido: refPlantilla,
    } = props;

    return (
        <div className="o-be-part-communities">
            <div className="container">
                <TitleSection
                    title={tituloGeneral}
                    introText={descripcion.json.content[0].content[0].value}
                />
                <div className="o-be-part-communities__container">
                    <div className="o-be-part-communities__container__image">
                        <img src={imagenPrincipal.file.url} />
                    </div>
                    <div className="o-be-part-communities__container__text">
                        {refPlantilla.map((item, index) => (
                            <IconCard
                                key={index}
                                title={item.tituloBanner}
                                description={documentToReactComponents(
                                    item.descripcion.json
                                )}
                                imageUrl={item.imagenPrincipal[0].file.url}
                                textButton={item.tituloBoton}
                                redirectButton={item.redireccionBoton}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BePartCommunities;
